module.exports = __webpack_public_path__ + "static/avatar_ww-e9d3bd45d7ca7aa525cee325c28bcd3b.png";